import { createSelector, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { sectionExtraReducers } from '@store/reducres/section.reducers'

export interface SectionState {
  sectionList: string[]
  loading: boolean
  error: string | null
}

const initialState: SectionState = {
  sectionList: [],
  loading: false,
  error: null,
}

const sectionSlice = createSlice({
  name: 'section',
  initialState,
  reducers: {},
  extraReducers: sectionExtraReducers,
})

export default sectionSlice.reducer

export const selectSection = (state: RootState) => state.section

export const selectSectionLoading = createSelector(
  [selectSection],
  (sections) => sections.loading
)
export const selectAllSections = createSelector(
  [selectSection],
  (sections) => sections.sectionList
)
